import axios from 'axios'
import store from '@/store'

// TODO: remove this and call from amazon's API
const getProducts = productIDs =>
  store.state.products.filter(({ asin }) => productIDs.indexOf(asin) > -1)

const getAllProductsById = productIDList => {
  return axios({
    method: 'GET',
    url: '/api/products',
    params: {
      productIDList
    }
  })
}

export { getProducts, getAllProductsById }
